import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Logo from "../../assets/images/logo.png";

import ButtonBG from "../../assets/images/icons/box.svg";
import AuthService from "../../services/auth.service";
import Toaster from "../../components/toaster";
import { useNavigate } from "react-router-dom";
import { setUser } from "../../store/slices/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { Check, Eye, EyeOff } from "lucide-react";
import Loader from "../../assets/images/quick-feet-loader.gif";

const Login = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const initialValues = {
    email: "",
    password: "",
    userLoginAs: "",
    login: true,
    // rememberMe: false,
  };

  // Define Yup validation schema
  const validationSchema = Yup.object({
    email: Yup.string().required("Email is required"),
    password: Yup.string().required("Password is required"),
    userLoginAs: Yup.string().required("User type is required"),
  });

  const handleSubmit = async ({ email, password, login, userLoginAs }) => {
    setLoading(true);
    try {
      const response = await AuthService?.login(
        email,
        password,
        login,
        userLoginAs
      );
      if (response) {
        localStorage.setItem("quickfeet_user", response.data.accessToken);
        dispatch(setUser(response.data.data));
        localStorage.setItem("email", response.data.data.email);
        localStorage.setItem("planName", response.data.data.planName);
        localStorage.setItem(
          "favoriteMilestone",
          response.data.data.favoriteMilestone
        );
        navigate("/", { replace: true });
        Toaster("success", response?.data?.message || "Login successful!");
      }
    } catch (error) {
      Toaster(
        "error",
        error?.response?.data?.message || "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  });

  return (
    <div className="h-screen px-4">
      <div className="flex items-center justify-center h-full">
        <div className="max-w-md w-full rounded-xl bg-white/50 p-5 lg:p-10">
          <div className="mb-10">
            <div className="h-20">
              <img
                src={Logo}
                alt="Logo"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
          <form onSubmit={formik.handleSubmit}>
            <div className="grid gap-4">
              {/* Email Input */}
              <div>
                <input
                  type="text"
                  name="email"
                  placeholder="Email"
                  autoComplete="off"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="p-2 border bg-white rounded w-full"
                />
                {formik.touched.email && formik.errors.email ? (
                  <div className="text-red-500">{formik.errors.email}</div>
                ) : null}
              </div>

              {/* Password Input */}
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Password"
                  autoComplete="off"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="p-2 border rounded bg-white w-full"
                />
                <div
                  className="absolute top-3 right-1 cursor-pointer"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </div>
                {formik.touched.password && formik.errors.password ? (
                  <div className="text-red-500">{formik.errors.password}</div>
                ) : null}
              </div>

              {/* User Type Select */}
              <div className="w-full">
                <select
                  name="userLoginAs"
                  value={formik.values.userLoginAs}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="p-2 border rounded bg-white focus:border-secondry focus:outline-none w-full h-[42px]"
                >
                  <option value="" disabled>
                    Select User Type
                  </option>
                  <option value="Player">Player</option>
                  <option value="Coach">Coach</option>
                  <option value="teacher">Teacher</option>
                </select>
                {formik.touched.userLoginAs && formik.errors.userLoginAs ? (
                  <div className="text-red-500">
                    {formik.errors.userLoginAs}
                  </div>
                ) : null}
              </div>

              {/* Remember Me Checkbox */}
              {/* <div className="flex gap-2 items-center justify-between">
                <div
                  className="flex items-center space-x-2 cursor-pointer"
                  onClick={() =>
                    formik.setFieldValue(
                      "rememberMe",
                      !formik.values.rememberMe
                    )
                  }
                >
                  <div
                    className={`w-4 h-4 border-2 rounded flex items-center justify-center ${
                      formik.values.rememberMe
                        ? "bg-primary border-primary"
                        : "border-gray-300 bg-white"
                    }`}
                  >
                    {formik.values.rememberMe && (
                      <Check size={16} color="white" />
                    )}
                  </div>
                  <span className="text-white">Remember me</span>
                </div>
              </div> */}

              {/* Login Button */}
              <div className="text-primary p-2 rounded mt-2 items-center w-full flex justify-center">
                <button
                  type="submit"
                  className="relative cursor-pointer w-fit h-14"
                >
                  <img
                    src={ButtonBG}
                    alt="Button Background"
                    className="w-full h-full"
                  />
                  <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 font-semibold text-base">
                    {loading ? <span class="loader mt-2"></span> : "Login"}
                  </span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
